const stats = [
  { value: '30+', label: 'Jahre Erfahrung', icon: 'ri-award-line' },
  { value: '500+', label: 'Realisierte Projekte', icon: 'ri-tools-line' },
  { value: '100%', label: 'Individuelle Lösungen', icon: 'ri-focus-3-line' },
  { value: '24h', label: 'Reaktionszeit', icon: 'ri-time-line' },
];

const values = [
  {
    icon: 'ri-user-heart-line',
    title: 'Kundenorientiert',
    description: 'Ihre Anforderungen stehen im Mittelpunkt. Wir hören zu, verstehen Ihre Prozesse und entwickeln Lösungen, die wirklich passen.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Praxisnah',
    description: 'Keine Standardlösungen von der Stange. Jedes Projekt wird individuell geplant und mit jahrzehntelangem Know-how umgesetzt.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Zuverlässig',
    description: 'Termintreue, transparente Kommunikation und nachhaltige Qualität – darauf können Sie sich bei gowiTEC verlassen.',
  },
];

const partners = [
  {
    name: 'OMRON',
    role: 'Partner',
    description: 'Als OMRON Partner programmieren und integrieren wir OMRON Sysmac SPS-Systeme (NJ / NX) in komplexe Automatisierungsanlagen – zuverlässig, präzise und zukunftssicher.',
  },
  {
    name: 'Loxone',
    role: 'Partner',
    description: 'Als Loxone Partner integrieren wir intelligente Gebäudeautomation und Sicherheitstechnik in Ihre Anlage.',
  },
];

const TrustSection = () => {
  return (
    <>
      {/* Stats Bar */}
      <section className="bg-[#1E3A8A] py-14">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                  <i className={`${stat.icon} text-white/70 text-2xl`}></i>
                </div>
                <div className="text-white text-4xl font-bold mb-1">{stat.value}</div>
                <div className="text-blue-200 text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="text-center mb-16">
            <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Warum gowiTEC</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-4">Technik mit Handschlagqualität</h2>
            <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
              Als inhabergeführtes Unternehmen verbinden wir technische Exzellenz mit persönlichem Engagement – für Lösungen, die langfristig funktionieren.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {values.map((val) => (
              <div key={val.title} className="bg-white rounded-xl p-8 border border-gray-100">
                <div className="w-12 h-12 flex items-center justify-center bg-[#EFF6FF] rounded-xl mb-6">
                  <i className={`${val.icon} text-[#1E3A8A] text-xl`}></i>
                </div>
                <h3 className="text-gray-900 font-semibold text-lg mb-3">{val.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{val.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partner-Logos */}
      <section className="py-20 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="text-center mb-12">
            <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Partnerschaften</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-4">Starke Partner an unserer Seite</h2>
            <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
              Durch enge Kooperationen mit führenden Herstellern bieten wir Ihnen Lösungen auf höchstem technischen Niveau.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
            {/* OMRON */}
            <div className="flex flex-col items-center text-center bg-[#F8FAFC] rounded-xl p-8 border border-gray-100">
              <div className="w-52 h-16 flex items-center justify-center mb-5 bg-white rounded-lg border border-gray-100 px-6">
                <img
                  src="https://storage.readdy-site.link/project_files/0c485b57-fedb-40d8-8940-c50727e75c3c/9668503a-dcd7-40d6-8bc5-9e13acd0327c_Omron-logo.jpg?v=c9c44afe4a42e3aac7d26ed2abc7929b"
                  alt="OMRON Logo"
                  className="max-w-full max-h-full object-contain"
                  loading="lazy"
                />
              </div>
              <span className="inline-block bg-[#EFF6FF] text-[#1E3A8A] text-xs font-semibold px-3 py-1 rounded-full mb-4">
                Partner
              </span>
              <p className="text-gray-500 text-sm leading-relaxed">
                Als OMRON Partner programmieren und integrieren wir OMRON Sysmac SPS-Systeme (NJ / NX) in komplexe Automatisierungsanlagen – zuverlässig, präzise und zukunftssicher.
              </p>
            </div>
            {/* Loxone */}
            <div className="flex flex-col items-center text-center bg-[#F8FAFC] rounded-xl p-8 border border-gray-100">
              <div className="w-52 h-16 flex items-center justify-center mb-5 bg-white rounded-lg border border-gray-100 px-6">
                <img
                  src="https://storage.readdy-site.link/project_files/0c485b57-fedb-40d8-8940-c50727e75c3c/cc570193-fe66-4bb7-9cb1-bc7bef89adab_loxo_partner.jpg?v=13213c94cd01057b5d8c1ee02d9584e3"
                  alt="Loxone Logo"
                  className="max-w-full max-h-full object-contain"
                  loading="lazy"
                />
              </div>
              <span className="inline-block bg-[#EFF6FF] text-[#1E3A8A] text-xs font-semibold px-3 py-1 rounded-full mb-4">
                Partner
              </span>
              <p className="text-gray-500 text-sm leading-relaxed">
                Als Loxone Partner integrieren wir intelligente Gebäudeautomation und Sicherheitstechnik in Ihre Anlage.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TrustSection;
